const PREFIX = ['platform', 'integrationDefinition'];
export function createIntegrationDefinitionRepository(config) {
    const { repository, client } = config;
    function getFindQueryKey(props) {
        return [...PREFIX, 'find', props];
    }
    function getRetrieveQueryKey(integrationDefinitionId) {
        return [...PREFIX, 'retrieve', integrationDefinitionId];
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getFindQueryKey(props),
                async queryFn() {
                    const response = await client.user.integrationDefinitionList(props);
                    return response.data.data;
                },
            });
            return query;
        },
        useRetrieve(context, integrationDefinitionId, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getRetrieveQueryKey(integrationDefinitionId),
                async queryFn() {
                    // Since there's no direct retrieve endpoint, we use the list endpoint
                    // and filter for the specific definition
                    const response = await client.user.integrationDefinitionList({});
                    const definition = response.data.data.find((def) => def.id === integrationDefinitionId);
                    if (!definition) {
                        throw new Error(`Integration definition with ID ${integrationDefinitionId} not found`);
                    }
                    return definition;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=integrationDefinitionRepository.js.map